module.exports = __webpack_public_path__ + "img/phone-outline-section-introduction.ec2a8929.png";